import { render, staticRenderFns } from "./PointCloud.vue?vue&type=template&id=0a4c5a75&"
import script from "./PointCloud.vue?vue&type=script&lang=js&"
export * from "./PointCloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports